import { EnumValue } from '@/components';
import { SaleTaxApplyTo } from '@/core';
import { enumValues } from '@/utils';
import { Select, Tooltip } from 'antd';
import { useCallback, useEffect, useState } from 'react';

interface Props {
  initialValue: SaleTaxApplyTo[] | undefined;
  resetOnInitialValueChange: true;
  disabled?: boolean;
  onSubmit: (value: SaleTaxApplyTo[] | undefined) => any;
  placeholder?: string;
  tooltipText?: React.ReactNode;
  showTooltip?: boolean;
}

export function PricingSettingsApplyTo(props: Props) {
  const {
    initialValue,
    disabled,
    onSubmit,
    placeholder,
    showTooltip,
    tooltipText,
  } = props;
  const [value, setValue] = useState(initialValue);
  useEffect(() => setValue(initialValue), [initialValue]);

  const handleSubmit = useCallback(
    (value: SaleTaxApplyTo[] | undefined) => {
      setValue(value);
      onSubmit(value);
    },
    [onSubmit],
  );

  const select = (
    <Select<SaleTaxApplyTo[]>
      className="w-100"
      value={value}
      labelInValue={false}
      onChange={handleSubmit}
      allowClear
      showSearch={false}
      disabled={disabled}
      mode="multiple"
      placeholder={placeholder}
    >
      {enumValues(SaleTaxApplyTo).map((value) => (
        <Select.Option key={value}>
          <EnumValue type={SaleTaxApplyTo} value={value} />
        </Select.Option>
      ))}
    </Select>
  );

  if (showTooltip && tooltipText != null) {
    return <Tooltip title={tooltipText}>{select}</Tooltip>;
  }

  return select;
}
